jQuery(document).foundation();


// jQuery(document).ready(function ($) {
//     // Ensure Foundation is initialized
//     // $(document).foundation();

//     // Manually initialize Foundation Sticky for each sticky element
//     $('[data-sticky]').each(function () {
//         new Foundation.Sticky($(this), {});
//     });
// });


